import { t } from "../../../../../utils/i18n";
import { formErrors } from "../../../../../utils/formErrors";

interface FormErrors {
  cardNumberError: string;
}
export const formattedErrors = (errors) => {
  const validationErrors = {} as FormErrors;

  const formatErrors = formErrors(errors);

  validationErrors.cardNumberError = formatErrors["card_number"];

  return validationErrors;
};

export function getCurrentDisplayStatus(
  cardStatus: string | undefined, 
  requestStatus: string | undefined
): string {
  return cardStatus || requestStatus || t("cards.common.not_available");
}